import reduce from 'lodash/reduce'

const SCHEMAS_MESSAGES = {
  INVALID: (v) => `Please enter a valid ${v}`,
  REQUIRED: (v) => `Please enter ${v}`,
  SELECT: (v) => `Please select ${v}`,
  MINIMUM: (fieldName, value) =>
    `${fieldName} must be ${value} characters long`,
  ONE_OF: (fieldName, options) =>
    `${fieldName} must be one of ${reduce(
      options,
      (prev, option, index) =>
        index === 0
          ? option
          : index < options.length - 1
          ? `${prev}, ${option}`
          : `${prev} or ${option}`,
      ''
    )}`,
}

export default SCHEMAS_MESSAGES
